import { render, staticRenderFns } from "./LogoFull.vue?vue&type=template&id=25cc6217&"
import script from "./LogoFull.vue?vue&type=script&lang=js&"
export * from "./LogoFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports